import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface CsSalvageDialogTask {
  _id: string;
  label: string;
  icon: string;
}

export interface CsSalvageDialogData {
  tasks: CsSalvageDialogTask[];
}

@Component({
  selector: 'cs-salvage-dialog',
  standalone: true,
  imports: [],
  templateUrl: './cs-salvage-dialog.component.html',
  styleUrl: './cs-salvage-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsSalvageDialogComponent {
  readonly dialogRef = inject(MatDialogRef<CsSalvageDialogComponent>);
  readonly data = inject<CsSalvageDialogData>(MAT_DIALOG_DATA);

  selectedTaskId = signal<string | null>(null);

  onTaskClick(task: CsSalvageDialogTask): void {
    if (this.selectedTaskId()) return;
    this.selectedTaskId.set(task._id);
    setTimeout(() => this.dialogRef.close(task), 500);
  }

  onNotToday(): void {
    this.dialogRef.close(null);
  }
}
